import { render, staticRenderFns } from "./MonitorConfig.vue?vue&type=template&id=f241f72e"
import script from "./MonitorConfig.vue?vue&type=script&lang=js"
export * from "./MonitorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports